<template>
    <div>
        <div
            class="absolute pin-b pin-r mr-md bg-accent-clay-orange-dark btn-circle text-white hover:bg-accent-clay-orange-dark-darker cursor-pointer z-20"
            :class="{ 'hidden': visible }"
            style="margin-bottom: 120px;"
            @click="visible = ! visible"
        >
            <font-awesome-icon icon="list" />
        </div>
        <div v-if="visible" class="h-full z-10 fixed pin-t pin-r bg-white w-1/3 ml-auto field-list-group">
            <div>
                <div class="bg-neutral-darkest p-lg">
                    <select-input
                        v-model="selectedStatus"
                        :options="statuses"
                        :opt-out-sorting="true"
                        class="mb-0"
                    />
                </div>
                <div>
                    <div
                        v-for="salesProject in filteredSalesProjects"
                        class="pl-xl py-lg cursor-pointer"
                        @click="select(salesProject)"
                    >
                        <span class="headline-sm font-semibold">
                            {{ salesProject.name }}
                        </span>

                        <span class="text-xs block mt-sm">
                            {{ salesProject.status_label }}
                        </span>
                    </div>
                    <div v-if="filteredSalesProjects.length < 1" class="m-lg">
                        <em>
                            Inga projekt kunde hittas på aktuell status
                        </em>
                    </div>
                </div>
            </div>
            <div style="margin-bottom: 235px;" />
            <div class="fixed pin-b p-lg flex justify-center w-1/3 field-list-group-action">
                <button
                    type="button"
                    class="btn btn-md is-ghost"
                    @click="close"
                >
                    Stäng
                </button>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                visible: false,
                selectedStatus: 'all',
                salesProjects: [],
                statuses: {
                    all: 'Alla statusar',
                    started: 'Under uppstart',
                    signup_open: 'Sälj pågår',
                    build_sale: 'Byggsälj',
                    awaiting_build: 'Inväntar bygg',
                    ongoing_build: 'Bygg pågår',
                    deployed: 'Eftermarknad',
                    cancelled: 'Annullerad',
                },
            };
        },
        computed: {
            filteredSalesProjects() {
                if (this.selectedStatus === 'all') {
                    return this.salesProjects;
                }

                return this.salesProjects.filter((salesProject) => {
                    return salesProject.status === this.selectedStatus;
                });
            },
        },
        async created() {
            const response = await axios.get(route('api.sales-projects.index'));
            this.salesProjects = response.data.filter((project) => {
                return project.possible_to_assign_delivery_project_count > 0;
            });
        },
        methods: {
            close() {
                this.visible = false;
            },
            select(salesProject) {
                EventBus.$emit('sales-project-selected', salesProject.id);
            },
            iconClass(salesProject) {
                return `text-${salesProject.status_color}`;
            },
        },
    };
</script>